module.exports = __webpack_public_path__ + "img/70dc0e0.png";